// extracted by mini-css-extract-plugin
export default {"container":"container___nooK6","content":"content___HfvP9","footer":"footer___QQ1BV"};